import { useTranslation } from "react-i18next";
import noDataFoundImg from "../../assets/icons/nodata.webp";
import "./DashboardGraphEmptyState.scss";

/** Common empty-state UI. Default image = nodata.webp. Pass imageSrc for channel assets. */
export default function DashboardGraphEmptyState({
  className = "",
  fullHeight = true,
  compact = false,
  variant,
  imageSrc,
  title,
}) {
  const { t } = useTranslation("dashboard");
  const isList = variant === "list";

  return (
    <div
      className={[
        "dashboard-graph-empty-state",
        fullHeight && !isList ? "dashboard-graph-empty-state--full" : "",
        compact && !isList ? "dashboard-graph-empty-state--compact" : "",
        isList ? "dashboard-graph-empty-state--list" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <img
        className="dashboard-graph-empty-state__image noShrink"
        src={imageSrc ?? noDataFoundImg}
        alt=""
        width={188}
        height={106}
        loading="lazy"
        decoding="async"
      />
      <p className="dashboard-graph-empty-state__title">
        {title ?? t("graphEmptyState.title", "No Data Found")}
      </p>
    </div>
  );
}

function chartSeriesNumericValue(point) {
  if (point == null) return 0;
  if (typeof point === "object" && !Array.isArray(point)) {
    const raw = point.y ?? point.rawValue ?? point.value ?? point.v;
    return Number(raw ?? 0);
  }
  return Number(point ?? 0);
}

/** Has-data helper for chart series — do not invent weaker checks. */
export function hasNumericSeriesData(values = []) {
  if (!Array.isArray(values) || values.length === 0) return false;
  return values.some((v) => chartSeriesNumericValue(v) > 0);
}

export function hasChartDatasetValues(chartData) {
  const datasets = chartData?.datasets;
  if (!Array.isArray(datasets) || datasets.length === 0) return false;
  return datasets.some((ds) => hasNumericSeriesData(ds?.data));
}
